import { ApolloClient } from '@apollo/client'

import {
  CustomerAddressInput,
  DeleteAddressDocument,
  GeoPoint,
  SaveAddressDocument,
  SaveAddressMutationResult,
  SearchForAddressSuggestionsDocument,
  SearchForAddressSuggestionsQueryResult,
  ZonesForGeoPointDocument,
  ZonesForGeoPointQueryResult,
} from '@shared/generated'

export class AddressApi {
  constructor (private readonly client: ApolloClient<unknown>) {}

  async saveAddress (addressInfo: CustomerAddressInput) {
    return (await this.client.mutate({
      mutation: SaveAddressDocument,
      variables: {
        addressInfo,
      },
    })) as SaveAddressMutationResult
  }

  async deleteAddress (deleteAddressId: string) {
    return await this.client.mutate({
      mutation: DeleteAddressDocument,
      variables: {
        deleteAddressId,
      },
    })
  }

  async zonesForGeopoint (geoPoint: {
    latitude: GeoPoint['latitude'];
    longitude: GeoPoint['longitude'];
  }) {
    return (await this.client.query({
      query: ZonesForGeoPointDocument,
      variables: {
        point: geoPoint,
      },
    })) as ZonesForGeoPointQueryResult
  }

  async searchAddress (geoPoint: {
    latitude: GeoPoint['latitude'];
    longitude: GeoPoint['longitude'];
  }) {
    return (await this.client.query({
      query: SearchForAddressSuggestionsDocument,
      variables: {
        addressFilter: geoPoint,
      },
    })) as SearchForAddressSuggestionsQueryResult
  }
}
